import React, { useEffect, useState } from "react";
import HoldingsTableMobile from "../HoldingReports/HoldingsTableMobile";
import di from "../../di/servicelocator";
import { useDispatch, useSelector } from "react-redux";
import MobSortDrop from "../../MobDropdowns/MobSortDrop";
import MobFilterAssetDrop from "../../MobDropdowns/MobFilterAssetDrop";
import Drawer from "react-bottom-drawer";
import MobDownloadDrop from "../../MobDropdowns/MobDownloadDrop";
import debounce from "@frameworks/web/utils/debounce";
import FilterLabels from "../../../../../components/generic/FilterLabels/FilterLabels";
import SortLabels from "@frameworks/web/components/generic/SortLabels/SortLabel";
import UnderstandingSectionMob from "../../../../../components/Reports/UnderstandingSection/UnderstandingSectionMob";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import QtyDrop from "../../DeskDropdowns/QtyDrop";
import EdButton from "../../../../generic/edbutton/edButton";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import HoldingSmallCaseReportMob from "../../dowloadHoldingReport/dowloadHoldingReportsMob/HoldingSmallCaseReportMob";
import ReportValue from "../../../../generic/commonTableVal";
import { ESortOrder } from "@domains/utils/sort";
import { GTMService } from "@di";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { retrieveExtPlatAccDataThunks } from "@frameworks/web/redux/reducers/RetrieveExtPlatAccData";
import { accountDetails } from "@di";
import { isLoginSourceEMT, } from "@domains/utils/emtReportCallback";
import { FilterTabEnum, tabWithAssetCategory, } from "@frameworks/web/components/Reports/CommonComponent/constant";
import { AssetCategory, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import FamilyTaggingMain from "@frameworks/web/components/Reports/FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
import familyDi from "@frameworks/web/components/Reports/FamilyTagging/di/servicelocator";
import InsuranceReportBanner from "@frameworks/web/components/Reports/HoldingReports/InsuranceInHoldings/InsuranceReportBanner";
import PopBodProcessBlock from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PopBodProcessBlock";
const HoldingReportMobile = (props) => {
    const dispatch = useDispatch();
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const [getStream, setGetStream] = React.useState(true);
    const [showQtyDropdown, setshowQtyDropdown] = React.useState(false);
    const [dataT, changeTableData] = React.useState("AllQty");
    const [ShowSortDrop, setShowSortDrop] = React.useState(false);
    const [ShowFilterAssetDrop, setShowFilterAssetDrop] = React.useState(false);
    const [isInsuranceTabOnly, setIsInsuranceTabOnly] = useState(false);
    const [ShowDownloadDrop, setShowDownloadDrop] = React.useState(false);
    const [showOptions, setShowOptions] = React.useState(false);
    const [selectedSortLable, setSelectedSortLable] = React.useState("");
    const [filterBubbles, setFilterBubbles] = useState([]);
    const [showSearch, setShowSearch] = React.useState(false);
    const [downloadSmallcase, setDownloadSmallcase] = React.useState(false);
    const [shimmer, setShimmer] = React.useState(true);
    /**********************Redux states************************* */
    const accountCode = useSelector((state) => state.accountDetailsReducer.accountCode);
    const familySelectedMember = useSelector((state) => state.FamilyTagging.familyDetails.reducersData.selectedMember);
    let isMyAccount = accountCode === (familySelectedMember === null || familySelectedMember === void 0 ? void 0 : familySelectedMember.accCode) || false;
    const holdingError = useSelector((state) => state.holdingReport.errorData);
    const emptyValidation = useSelector((state) => state.holdingReport.emptyValidation);
    const responseData = useSelector((state) => state.understandSection.data);
    const filter = useSelector((state) => state.holdingReport.data.FilterData);
    const selectedProduct = useSelector((state) => state.holdingReport.prodDropDown);
    const finalSortList = useSelector((state) => state.holdingReport.data.SortData);
    const holdingSummary = useSelector((state) => { var _a, _b; return (_b = (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.HoldingSummary; });
    const { HoldingDataFlags: HoldingDataFlags } = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.holdingReport) === null || _a === void 0 ? void 0 : _a.data; });
    const HoldingData = useSelector((state) => { var _a; return (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data; });
    const isSummarize = useSelector((state) => state.holdingReport.data.IsSummarize);
    const { simpleFilter, assetFilter, productAssetFilter } = filter;
    const qts = [{ title: "All Quantity" }, { title: "Tradeable Quantity" }];
    /***********************Functions******************************* */
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };
    const removeFilter = async (title) => {
        di.holdingReport.removeFilters(title);
    };
    const clearAllFilter = async () => {
        if ((props === null || props === void 0 ? void 0 : props.keyTab) === FilterTabEnum.ALL) {
            sessionStorage.removeItem("assetFilter");
            di.holdingReport.clearAllFilters();
        }
        else
            di.holdingReport.clearSingleFilter("simpleFilter");
    };
    const resetSort = () => {
        di.holdingReport.getSortedHoldingReportData({
            displayName: "Alphabetical",
            order: ESortOrder.DESC,
            sortName: "displayName",
        }, false);
        //above will update in finalSortList through  usecase
        setShowSortDrop(false);
    };
    const clearAllLabels = () => {
        resetSort();
        clearAllFilter();
    };
    var handleSearchInput = (e) => {
        setSearchVal(e.target.value);
        debounce(async function () {
            di.holdingReport.getSearchHoldingReportData(e.target.value);
        }, 300)();
    };
    const [searchVal, setSearchVal] = React.useState(useSelector((state) => { var _a, _b; return (_b = (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.SearchData; }));
    var resetSearch = async () => {
        setSearchVal("");
        di.holdingReport.getSearchHoldingReportData("");
    };
    const hideSearch = async () => {
        setShowSearch(false);
        setSearchVal("");
        di.holdingReport.getSearchHoldingReportData("");
    };
    const handleisSummarizeClick = async (e) => {
        di.holdingReport.getSummarizeHoldingReportData(e.target.checked);
    };
    const getPledgeLink = (loader) => {
        if (loader !== undefined && loader)
            return "";
        else {
            props === null || props === void 0 ? void 0 : props.setLoader(loader);
            window.open(di.holdingReport.edisOrPledgeUrl, "_blank");
        }
    };
    const getAccountDataFromExPlat = async () => {
        const loginSource = await accountDetails.getLoginSrc();
        if (isLoginSourceEMT(loginSource)) {
            props === null || props === void 0 ? void 0 : props.setLoader(true);
            dispatch(retrieveExtPlatAccDataThunks(getPledgeLink));
        }
        else {
            getPledgeLink(false);
        }
    };
    const GTMTagHandle = () => {
        if (isMyAccount && !isInsuranceTabOnly) {
            getAccountDataFromExPlat();
            GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.TapPledge, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, di.holdingReport.isNonPoaClient
                ? ReportsGTMConstants.Authorize
                : ReportsGTMConstants.Pledge));
        }
    };
    const selectAssetProduct = (selected) => {
        setShowOptions(false);
        if (selected.display !== "All") {
            di.holdingReport.onProductChange(selected);
        }
        else {
            di.holdingReport.onAssetChange(tabWithAssetCategory[props === null || props === void 0 ? void 0 : props.keyTab]);
        }
        di.holdingReport.saveProdAssetDropDown(selected, props.keyTab);
        if (props.keyTab === "Other")
            GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.PNL, ReportsGTMConstants.NewReports, `${ReportsGTMConstants.Others} | ${selected}`));
    };
    /*****************************UseEffects*********************************** */
    React.useEffect(() => {
        if ((holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.date) ||
            (holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.totalPnL) ||
            (holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.totalInvestment) ||
            holdingError.isOpen !== null) {
            setShimmer(false);
        }
    });
    const openDrawerSort = React.useCallback(() => setShowSortDrop(true), []);
    const closeDrawerSort = React.useCallback(() => setShowSortDrop(false), []);
    const openDrawerFilterAsset = React.useCallback(() => setShowFilterAssetDrop(true), []);
    const closeDrawerFilterAsset = React.useCallback(() => setShowFilterAssetDrop(false), []);
    const openDrawerDownload = React.useCallback(() => setShowDownloadDrop(true), []);
    const closeDrawerDownload = React.useCallback(() => setShowDownloadDrop(false), []);
    useEffect(() => {
        let bubbles = [];
        let selectedAsset = [];
        if ((props === null || props === void 0 ? void 0 : props.keyTab) === FilterTabEnum.ALL) {
            // for other tabs asset filter bubbles should not be  shown,  as user  is already in that asset
            assetFilter.filters.map((asset) => {
                if (asset.selected) {
                    bubbles.push(asset.title);
                    selectedAsset.push(asset.key);
                }
            });
        }
        simpleFilter.filters.map((filterFlag) => {
            if (filterFlag.selected) {
                bubbles.push(filterFlag.title);
            }
        });
        setFilterBubbles(bubbles);
        // check whether user select only insurance  asset
        let insuranceTab = (props === null || props === void 0 ? void 0 : props.keyTab) === FilterTabEnum.INSURANCE ||
            (selectedAsset.length === 1 &&
                selectedAsset[0] === AssetCategory.LifeInsurance);
        if (insuranceTab) {
            //not applicable for only insurance asset, so we have to reset and disable
            di.holdingReport.toggleQtyBreakDown(false);
            changeTableData("AllQty");
        }
        setIsInsuranceTabOnly(insuranceTab);
    }, [
        JSON.stringify(simpleFilter.filters),
        JSON.stringify(assetFilter.filters),
    ]);
    useEffect(() => {
        let selectedSort = finalSortList.find((sort) => sort.order !== ESortOrder.UNCHANGED);
        if ((selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.displayName) == "Alphabetical" &&
            (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.order) === -1) {
            //becoz  Alphabetical + ascending is default sort  no need to display
            setSelectedSortLable("");
        }
        else
            setSelectedSortLable(selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.displayName);
    }, [finalSortList]);
    useEffect(() => {
        if (di.holdingReport.symbols.length > 0 && getStream) {
            setGetStream(false);
            di.holdingReport.getHoldingStreamData(true);
        }
    }, [di.holdingReport.symbols]);
    useEffect(() => {
        setTimeout(() => {
            var _a;
            (_a = familyDi === null || familyDi === void 0 ? void 0 : familyDi.familyTagging) === null || _a === void 0 ? void 0 : _a.setStopFamilyAPICall(true);
        }, 0);
        di.holdingReport.fetchEdisOrEpledgeUrl();
        di.holdingReport.getDefaultEmail();
        window.addEventListener("scroll", handleScroll);
        di.holdingReport.getUnderstandingSectionData();
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        shimmer ? (React.createElement(Skeleton, { height: 167, className: "mt-3" })) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `${" d-flex justify-content-between align-items-center pt-10 pb-10 gap-10"}` },
                (props === null || props === void 0 ? void 0 : props.assetFilter.showList) && (React.createElement("div", { className: "posrel" },
                    React.createElement("div", { onClick: () => setShowOptions(!showOptions), className: "selected_option m-0" },
                        selectedProduct && React.createElement("span", null, selectedProduct.display),
                        React.createElement("span", { className: "edel-icon-arrow-down" })),
                    showOptions && (React.createElement("div", { className: "select_options" }, props === null || props === void 0 ? void 0 : props.assetFilter.assetProductList.map((x) => {
                        return (React.createElement("span", { onClick: () => selectAssetProduct(x) }, x.display));
                    }))))),
                React.createElement("div", { className: "w-100" },
                    React.createElement(FamilyTaggingMain, { hideConsolidated: true, oldTheme: true }))),
            (props === null || props === void 0 ? void 0 : props.keyTab) != FilterTabEnum.INSURANCE &&
                !props.isInsuranceVisited && (React.createElement("div", { className: "w-100" },
                React.createElement(InsuranceReportBanner, { setIsInsuranceVisited: props === null || props === void 0 ? void 0 : props.setIsInsuranceVisited }))),
            HoldingDataFlags.isBodEnabled && HoldingData.HoldingDetails.length > 0 && (React.createElement(PopBodProcessBlock, { bodProcessInfoMessage: HoldingDataFlags.bodProcessInfoMessage })),
            React.createElement("div", { className: "div market-status monochrome-light-gray-border " },
                React.createElement("div", { className: "d-flex justify-content-between" },
                    React.createElement("div", { className: "col" },
                        React.createElement("div", { className: "investment-mob" },
                            React.createElement("div", { className: "inv-head" },
                                React.createElement("h3", { className: "mb-0" }, " Total Investment ")),
                            React.createElement("div", { className: "inv-val" },
                                React.createElement(ReportValue, { parentClass: "mb-0", val: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.totalInvestment, stream: false, onlyval: false, defaultReturn: "-" })))),
                    React.createElement("div", { className: "col" },
                        React.createElement("div", { className: "curr-val-mob " },
                            React.createElement("div", { className: "curr-val-head" },
                                React.createElement("h3", { className: "mb-0" }, " Current Value ")),
                            React.createElement("div", { className: "curr-val" },
                                React.createElement(ReportValue, { parentClass: "mb-0", val: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.currentValue, stream: false, onlyval: false, defaultReturn: "-" })))),
                    React.createElement("div", { className: "col" },
                        React.createElement("div", { className: "tot-prof-loss-mob" },
                            React.createElement("div", { className: "totalpnl-heading" },
                                React.createElement("h3", { className: "mb-0" }, " Total P&L ")),
                            React.createElement("div", { className: "totalpnl-val lh-140 flexCenter gap-1" },
                                React.createElement(ReportValue, { parentClass: "RobotoR_14_400 ", val: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.totalPnL, stream: true, onlyval: false, defaultReturn: "-" }),
                                React.createElement(ReportValue, { parentClass: "Roboto_11_400", val: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.totalPnLChange, stream: true, onlyval: false, defaultReturn: "-", percentage: true })))))),
            React.createElement("div", { className: `png-container-wrapper
           ${scrollPosition > 150
                    ? "png-container-dock docked_box_shadow_mob"
                    : ""}
           ` },
                React.createElement("div", { className: `d-flex dayspnl-container ${showSearch ? "border-on-search-none" : ""}` },
                    React.createElement("div", { className: "col-6 align-self-center" },
                        React.createElement("div", { className: "days-prof-loss-mob" },
                            React.createElement("h3", { className: "mb-0" }, "Day's P&L "))),
                    React.createElement("div", { className: "col-6" },
                        React.createElement(ReportValue, { parentClass: "dayspnl", val: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.daysPnL, stream: true, onlyval: false, defaultReturn: "-" }),
                        React.createElement(ReportValue, { parentClass: "daypnlchange", val: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.daysPnLChange, stream: true, onlyval: false, defaultReturn: "-", percentage: true })))))),
        React.createElement("div", { className: "wrapper-fil", id: "search-filter" },
            React.createElement("div", { className: "d-flex", id: "summarize-mob" },
                React.createElement("div", { className: "quantity text-end" },
                    React.createElement("div", { className: `d-flex align-items-center tap-to-pledge ${!isMyAccount || isInsuranceTabOnly
                            ? " opacity-50 cursor_not_allowed"
                            : ""}` },
                        React.createElement("i", { className: "edel-icon-pledge" }),
                        React.createElement("a", { target: "_blank", onClick: GTMTagHandle }, di.holdingReport.isNonPoaClient ? "Authorize" : "Pledge"))),
                React.createElement("div", { className: "summarize" },
                    React.createElement("label", { className: "custom-control border-switch", style: { marginBottom: "3px" } },
                        React.createElement("input", { type: "checkbox", className: "border-switch-control-input border-switch-control-input-new", onClick: handleisSummarizeClick, defaultChecked: isSummarize, disabled: (holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) ||
                                emptyValidation.icon ===
                                    EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS].icon }),
                        React.createElement("span", { className: "border-switch-control-indicator" }),
                        React.createElement("span", { className: "teleport-switch-control-description" }, "Summarize"))),
                React.createElement("div", { className: `all-quantity ${(!isMyAccount || isInsuranceTabOnly) &&
                        "opacity-50 cursor_not_allowed"}` },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement(EdButton, { className: "btn-select-qty-mob", onClick: () => {
                                if (isMyAccount)
                                    setshowQtyDropdown(!showQtyDropdown);
                            }, value: dataT == "AllQty" ? "All Quantity" : "Tradeable Qty", btnTyp: "blue-link", disabled: (holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) ||
                                emptyValidation.icon ===
                                    EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS]
                                        .icon ||
                                shimmer ||
                                !isMyAccount ||
                                isInsuranceTabOnly }),
                        React.createElement("i", { className: "edel-icon-arrow-down" })),
                    showQtyDropdown && (React.createElement("div", { style: { position: "relative" }, className: !isMyAccount && "opacity-75 cursor_not_allowed" },
                        React.createElement(QtyDrop, { qts: qts, changeTableData: changeTableData, setshowQtyDropdown: setshowQtyDropdown }))))),
            React.createElement("div", { className: `filter-wrapper ${showSearch && scrollPosition > 150 ? "dock-filterbar-mob" : ""}
          ${filterBubbles.length > 0 || selectedSortLable
                    ? "dock-filterbar-mob-top-push"
                    : ""}
          `, style: { padding: "7px 0px" } },
                React.createElement("div", { className: "searchbar-c", style: { width: "85%", height: "36px" } },
                    React.createElement("label", { htmlFor: showSearch ? "focus-input" : "" }, showSearch ? (React.createElement("i", { className: `edel-icon-left-arrow ${showSearch ? "bg-white left-thin-arrow-expand" : ""}`, onClick: hideSearch })) : (React.createElement("i", { className: "edel-icon-bold-search", onClick: () => {
                            if (!((holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) ||
                                emptyValidation.icon ===
                                    EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS]
                                        .icon ||
                                shimmer))
                                setShowSearch(true);
                        } }))),
                    React.createElement("input", { id: "focus-input", type: "search", className: `${showSearch ? " bg-white p-10" : ""}`, name: "search", onChange: handleSearchInput, value: searchVal, onFocus: () => setShowSearch(true), onBlur: () => (!searchVal ? setShowSearch(false) : ""), autoComplete: "off", disabled: (holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) ||
                            emptyValidation.icon ===
                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS].icon ||
                            shimmer }),
                    showSearch && (React.createElement("label", { htmlFor: "focus-input" },
                        React.createElement("i", { className: `edel-icon-close ${showSearch ? "close-expand bg-white" : ""}  `, onClick: resetSearch })))),
                React.createElement("div", { className: "sort" },
                    React.createElement("button", { className: "btn  sorting", onClick: openDrawerSort, disabled: (holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) ||
                            emptyValidation.icon ===
                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS].icon ||
                            shimmer },
                        React.createElement("i", { className: "edel-icon-sort sort-filter-icon" }, selectedSortLable && (React.createElement("span", { className: "sort-filter-selected" }))))),
                React.createElement("div", { className: "filter" },
                    React.createElement("button", { className: "btn filter", onClick: openDrawerFilterAsset, disabled: (holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) ||
                            emptyValidation.icon ===
                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS].icon ||
                            shimmer ||
                            (props === null || props === void 0 ? void 0 : props.keyTab) === FilterTabEnum.INSURANCE },
                        React.createElement("i", { className: "edel-icon-curved-filter filter-icon" }, filterBubbles.length > 0 && (React.createElement("span", { className: "filter-selected" }))))),
                React.createElement("div", { className: "downloads" },
                    React.createElement("button", { className: "btn  download", onClick: () => {
                            if (!((holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) || shimmer))
                                openDrawerDownload();
                        } },
                        React.createElement("i", { className: "edel-icon-bold-download" }))))),
        (filterBubbles.length > 0 || selectedSortLable) && (React.createElement("div", { className: `filters-tag $scroll ${scrollPosition > 150 ? "filters-tag-sticky" : ""}
          ${scrollPosition > 150 && showSearch ? "dockfilters-tag-push" : ""}
          ` },
            selectedSortLable && (React.createElement(SortLabels, { LabelText: selectedSortLable, closeBtn: true })),
            filterBubbles.map((title) => (React.createElement(FilterLabels, { LabelText: title, closeBtn: true, FilterAction: removeFilter }))),
            React.createElement("div", { className: "clear-all-tag" },
                React.createElement(FilterLabels, { LabelText: " Clear All", closeBtn: false, FilterAction: clearAllLabels })))),
        React.createElement("div", { className: "ed-holding-table-mobile" },
            React.createElement(HoldingsTableMobile, { setOpenDrawer: props === null || props === void 0 ? void 0 : props.setOpenDrawer, searchVal: searchVal, quantityVal: dataT, shimmer: shimmer, keyTab: props.keyTab })),
        React.createElement("div", null, responseData &&
            responseData.reportDetails &&
            responseData.reportDetails.length > 0 && (React.createElement("div", { id: "understanding-section", className: `${shimmer ? "height-75" : " height-123"}` },
            React.createElement(UnderstandingSectionMob, { understandingData: responseData, reportType: ReportsGTMConstants.Holding })))),
        downloadSmallcase && (React.createElement(HoldingSmallCaseReportMob, { setDownloadSmallcase: setDownloadSmallcase, downloadSmallcase: downloadSmallcase })),
        ShowSortDrop && (React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerSort, isVisible: ShowSortDrop, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
            React.createElement(MobSortDrop, { setShowSortDrop: setShowSortDrop, sortByFilters: finalSortList }))),
        ShowFilterAssetDrop && (React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerFilterAsset, isVisible: ShowFilterAssetDrop, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
            React.createElement(MobFilterAssetDrop, { setshowFilterAssetDropdown: setShowFilterAssetDrop, filterData: { simpleFilter, assetFilter, productAssetFilter }, fullSize: true, labeltext: true, showAsset: (props === null || props === void 0 ? void 0 : props.keyTab) === FilterTabEnum.ALL, keyTab: props === null || props === void 0 ? void 0 : props.keyTab }))),
        ShowDownloadDrop && (React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerDownload, isVisible: ShowDownloadDrop, className: "download-drawer__handle-wrapper" },
            React.createElement(MobDownloadDrop, { setDownloadSmallcase: setDownloadSmallcase, setShowDownloadDrop: setShowDownloadDrop, accCodes: props.accCodes })))));
};
export default HoldingReportMobile;
